import api from "./api-service";
import { findNotSynced } from "@/services/local/therapies-service";
import { TherapyStatusEnum } from "@/domains/therapy/shared/application/therapy-status.enum";

const url = "therapys";

const findByTherapist = async () => {
  let offline = await findNotSynced();

  // 🔥 FIX: Remove terapias do IndexedDB que tenham draftId
  // (após refatoração, terapias com draft devem estar apenas na nuvem)
  offline = offline.filter((therapy) => {
    if (therapy.draftId) {
      //console.log(
      //  "[findByTherapist] ⚠️ Ignorando terapia órfã com draftId no IndexedDB:",
      //  therapy.draftId,
      //  "- localId:",
      //  therapy.localId
      //);
      return false;
    }
    return true;
  });

  if (navigator.onLine) {
    const offlineFormatted = offline.map((therapy) => ({
      patientName: therapy.patient?.name,
      realizedAt: therapy.createdAtLocal,
      status: therapy.status,
      therapy,
    }));
    const { data: online } = await api().get(`${url}/therapist`);
    return [...offlineFormatted, ...online];
  } else {
    return offline;
  }
};

const findByLoggedUserPatient = () => {
  return api().get(url + "/patient");
};

const findOnePatient = (id) => {
  return api().get(`${url}/${id}/patient`);
};

const findOneTherapist = (protocol) => {
  return api().get(`${url}/${protocol}/therapist`);
};

const getTherapyAttachments = (protocol) => {
  return api().get(`${url}/${protocol}/attachments`);
};

export const findLastTherapyQuestions = (userEmail) => {
  return api().get(`${url}/last-therapy-with-questions?userEmail=${userEmail}`);
};

const create = (obj) => {
  return api().post(url, obj);
};

const sendToQueue = (therapy) => api().post();

const softDelete = (protocol) => {
  return api().delete(`${url}/${protocol}`);
};

const downloadTherapistPdf = async (protocol) => {
  const response = await api().get(`${url}/${protocol}/pdf/therapist`, {
    responseType: "blob",
  });
  return response.data;
};

const downloadPatientPdf = async (protocol) => {
  const response = await api().get(`${url}/${protocol}/pdf/patient`, {
    responseType: "blob",
  });
  return response.data;
};

const downloadTherapistBatchPdf = async (protocols) => {
  const response = await api().post(
    `${url}/batch/pdf/therapist`,
    {
      protocols,
    },
    {
      responseType: "blob",
    }
  );
  return response.data;
};

const downloadPatientBatchPdf = async (protocols) => {
  const response = await api().post(
    `${url}/batch/pdf/patient`,
    {
      protocols,
    },
    {
      responseType: "blob",
    }
  );
  return response.data;
};

export {
  findByTherapist,
  create,
  findByLoggedUserPatient,
  findOnePatient,
  findOneTherapist,
  getTherapyAttachments,
  softDelete,
  downloadTherapistPdf,
  downloadPatientPdf,
  downloadTherapistBatchPdf,
  downloadPatientBatchPdf,
};

export const updateTherapyRating = (therapyId, rating) =>
  api().patch(`${url}/${therapyId}/rating`, { therapistRating: rating });
